import React, { useEffect, useState } from "react";
import Documents from "./ProviderDetails/Documents";
import Overview from "./ProviderDetails/Overview";
import { useGetAllDocumentsList } from "../custom-hooks/queries";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { libraryDocumentTypes } from "../utils/vqaOnlyOrg";

const CustomTabs = ({ Services, isLoading, hideVqq = false }) => {
  const [activeTab, setActiveTab] = useState("Overview");
  const [selectedTab, setSelectedTab] = useState("Overview");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedIds, setSelectedIds] = useState({
    docType: [],
    status: [],
    services: [],
  });

  const { id } = useParams();
  const searchQuery =
    useSelector(
      (state) => state.providersFilters.searchTextByPage["myDocuments"]
    ) || "";

  // Reset to page 1 when filters, search, or vendor change (matches DocumentLibrary)
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedIds, searchQuery, id]);

  const {
    data,
    isLoading: docsLoading,
    isError,
    error,
    refetch: cardsRefetch,
  } = useGetAllDocumentsList(
    currentPage,
    searchQuery,
    libraryDocumentTypes(selectedIds.docType, hideVqq),
    [id],
    selectedIds.status,
    selectedIds.services
  );

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSelectedTab(tab);
  };

  let totalCount = data?.total_items || 0;

  return (
    <div>
      {!isLoading && (
        <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700">
          <ul className="flex flex-wrap -mb-px px-3">
            <li className="me-2">
              <button
                className={`inline-block p-4 border-b-2 rounded-t-lg ${
                  activeTab === "Overview"
                    ? "text-[rgb(147,51,234)] border-[rgb(147,51,234)]"
                    : "border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300"
                }`}
                onClick={() => handleTabChange("Overview")}
              >
                Overview
              </button>
            </li>
            <li className="me-2">
              <button
                className={`inline-block p-4 border-b-2 rounded-t-lg ${
                  activeTab === "Documents"
                    ? "text-[rgb(147,51,234)] border-[rgb(147,51,234)]"
                    : "border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300"
                }`}
                onClick={() => handleTabChange("Documents")}
              >
                Documents ({totalCount})
              </button>
            </li>
          </ul>
        </div>
      )}
      <div>
        {selectedTab === "Documents" && (
          <Documents
            data={data}
            Services={Services}
            isLoading={docsLoading}
            isError={isError}
            error={error}
            cardsRefetch={cardsRefetch}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            searchQuery={searchQuery}
            hideVqq={hideVqq}
          />
        )}
      </div>
      <div>
        {selectedTab === "Overview" && (
          <Overview services={Services} />
        )}
      </div>
    </div>
  );
};

export default CustomTabs;
